export const BASE_PATH = "/home/project/app";

export const IMAGE_EXTENSION_PATTERN = /\.(ico|png|bmp|gif|jpg|jpeg|webp|svg)$/i;

export const UNWATCHABLE_EXTENSION_PATTERN: RegExp = /\.sqlite3/;
